<template>
  <ion-modal id="safe-modal" ref="safaModalRef" :is-open="isOpen" @didDismiss="closeTip">
    <div class="safe-container">
      <div class="safe-box">
        <img class="safe-box-img" :src="getBrandImageUrl('ai_smart_reading/safe_img.png')" alt="" />
        <div class="safe-box-title">检测到敏感词汇！！</div>
        <div class="safe-box-content">
          {{
            wordMsg
          }}是不文明且不适合在正式场合使用的词汇哦。我们应该倡导文明用语，保持良好的交流氛围呢。
        </div>
        <div class="safe-box-button" @click="closeTip">知道了</div>
      </div>
    </div>
  </ion-modal>
</template>
<script setup lang="ts">
import { defineProps, withDefaults, ref, computed } from "vue";
import { IonModal } from "@ionic/vue";
import { useToggle } from "@vueuse/core";
import { getBrandImageUrl } from "@/js/brandImages";

const props = withDefaults(
  defineProps<{
    msg: string;
  }>(),
  {
    msg: "",
  }
);

const [isOpen, changeIsOpen] = useToggle(true);
const safaModalRef = ref();
const wordMsg = computed(() => {
  const wordMatch = props.msg.match(/\[(.+)]/);
  const wordList = wordMatch ? wordMatch[1].split(",") : [];
  const wordResult = wordList.map((word) => word.replace(/(?<=\w)\w(?=\w)/g, "*")).join(",");
  return `【${wordResult}】`;
});
function closeTip() {
  changeIsOpen(false);
}
</script>

<style scoped lang="less">
@import "@/styles/variables.less";

ion-modal#safe-modal {
  --height: fit-content;
  --background: transparent;
}
.safe-container {
  height: 30rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.safe-box {
  background: #ffffff url("@{base-url}ai_smart_reading/safe_bg.png") no-repeat 0 0/100% 100%;
  border-radius: 2rem;
  position: relative;
  width: 80%;
  margin: 0 auto;
  padding: 5rem 2rem 3rem;
  &-img {
    position: absolute;
    top: -3rem;
    left: 50%;
    transform: translateX(-50%);
    width: 10rem;
  }
  &-title {
    text-align: center;
    color: #262626;
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    font-weight: bold;
  }
  &-content {
    color: #868f9e;
    font-size: 1rem;
    line-height: 1.5rem;
  }
  &-button {
    height: 3rem;
    background: #2bca9c;
    border-radius: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 1rem;
    margin: 2rem auto 0;
    width: 80%;
  }
}
</style>
